/**
 * @generated SignedSource<<152b626b8cf6ed5035383ad314b081f3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectIndicatorJS_project$data = {
  readonly name: string | null;
  readonly companyProjectId: number | null;
  readonly customProjectId: string | null;
  readonly projectColor: string | null;
  readonly " $fragmentType": "ProjectIndicatorJS_project";
};
export type ProjectIndicatorJS_project$key = {
  readonly " $data"?: ProjectIndicatorJS_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectIndicatorJS_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectIndicatorJS_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectColor",
      "storageKey": null
    }
  ],
  "type": "ProjectType",
  "abstractKey": null
};

(node as any).hash = "d0190be616dd55432ea6895a64642443";

export default node;
